var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        {
          attrs: {
            title:
              "Información de contacto del contratista de servicios profesionales "
          }
        },
        [
          _c("div", { staticClass: "row bg-white m-2 p-3 rounded" }, [
            !_vm.isReadOnly
              ? _c(
                  "div",
                  { staticClass: "my-3 p-2 col-12" },
                  [
                    _c("custom-separator", {
                      staticClass: "my-4",
                      attrs: { text: "Contratistas Seleccionados" }
                    }),
                    _vm.model.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center mt-4 pr-2"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mr-3" },
                              [
                                _c("check-box", {
                                  class: [
                                    { "text-green": _vm.model.length > 0 }
                                  ],
                                  attrs: {
                                    text: `Deseleccionar Todo (${_vm.model.length})`,
                                    value: true
                                  },
                                  on: { input: _vm.onDeselectAllSelected }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12 my-2" },
              [_vm._t("contractor-error")],
              2
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm._l(_vm.visibleItems, function(row) {
                  return _c(
                    "div",
                    { key: "sel-" + row.id },
                    [
                      _c("provider-row", {
                        attrs: {
                          data: { ...row, checked: true },
                          "is-read-only": _vm.isReadOnly
                        },
                        on: { toggle: _vm.onToggleFromSelected }
                      })
                    ],
                    1
                  )
                }),
                _vm.canShowMore
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center my-3" },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              variant:
                                "outline-success custom-view-more actionButton rounded-pill"
                            },
                            on: { click: _vm.loadMore }
                          },
                          [
                            _vm._v(" Ver más "),
                            _c("i", { staticClass: "ml-1 fas fa-chevron-down" })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.model.length <= 0
                  ? _c("custom-result-not-found", {
                      attrs: { text: "No hay información disponible." }
                    })
                  : _vm._e()
              ],
              2
            ),
            !_vm.isReadOnly && !_vm.isAddMode
              ? _c(
                  "div",
                  { staticClass: "col my-3" },
                  [
                    _c("custom-input", {
                      attrs: {
                        icon: "fal fa-search color-primary-2",
                        "left-icon": "",
                        placeholder: "SSN o Nombre del Proveedor",
                        "prepend-icon-type": "success"
                      },
                      on: { input: _vm.onSsnInput },
                      model: {
                        value: _vm.ssnName,
                        callback: function($$v) {
                          _vm.ssnName = $$v
                        },
                        expression: "ssnName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isReadOnly && !_vm.isAddMode
              ? _c(
                  "div",
                  { staticClass: "col-auto my-3" },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fal fa-search",
                        text: "Buscar",
                        variant: "success px-3"
                      },
                      on: { click: _vm.searchByCriteria }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.isAddMode
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("add-provider", {
                      on: {
                        add: _vm.onAddNewContractor,
                        cancel: _vm.onToggleAddForm
                      },
                      model: {
                        value: _vm.ssnName,
                        callback: function($$v) {
                          _vm.ssnName = $$v
                        },
                        expression: "ssnName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isReadOnly && !_vm.isAddMode
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("custom-separator", {
                      staticClass: "my-4",
                      attrs: { text: "Resultados" }
                    }),
                    _vm.filteredResults.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center my-3 p-2"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mr-3" },
                              [
                                _c("check-box", {
                                  class: [
                                    {
                                      "text-green":
                                        _vm.filteredResults.length > 0
                                    }
                                  ],
                                  attrs: {
                                    text: `Seleccionar Todo (${_vm.filteredResults.length})`,
                                    value: false
                                  },
                                  on: { input: _vm.onSelectAllResults }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.results, function(row) {
                      return _c(
                        "div",
                        { key: "res-" + row.id },
                        [
                          _c("provider-row", {
                            attrs: {
                              data: {
                                ...row,
                                checked: _vm.selectedIds.has(row.id)
                              },
                              "is-disabled": _vm.selectedIds.has(row.id),
                              "is-read-only": _vm.isReadOnly
                            },
                            on: { toggle: _vm.onToggleFromResults }
                          })
                        ],
                        1
                      )
                    }),
                    _vm.showNoResults
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify content-center flex-column align-items-center my-5"
                          },
                          [
                            _c("custom-result-not-found", {
                              attrs: { text: "No se encontró Contratista." }
                            }),
                            _vm.showAddLink
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-green pointer",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.onToggleAddForm.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-plus mr-2"
                                    }),
                                    _vm._v(" Añadir Contratista ")
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showPagination
                      ? _c("pagination", {
                          attrs: { data: _vm.pagination, "show-text": "" },
                          on: { "pagination-go-page": _vm.goToPageHandler }
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }